module.exports = __webpack_public_path__ + "img/traffic-junction-1.c9e1d51b.webp";